<div class="dialog-container">
  <lib-dialog-header (closeClick)="closeClicked()" i18n>
    Image Cropping
  </lib-dialog-header>
  <div class="dialog-content">
    <image-cropper
      [imageFile]="imageFiles()[currentlyCroppingImageIndex()]"
      [maintainAspectRatio]="true"
      [aspectRatio]="1"
      (imageCropped)="imageCropped($event)"></image-cropper>
    <div class="font-label-small font-tertiary"
         [hidden]="imageFiles().length <= 1">{{ currentlyCroppingImageIndex() + 1 }}/{{ imageFiles().length }}
    </div>
  </div>
  <div class="dialog-footer">
    <lib-button [type]="ButtonType.secondary" (buttonClick)="secondaryButtonClicked()" i18n>
      Discard Upload
    </lib-button>
    <lib-button [type]="ButtonType.primary" (buttonClick)="primaryButtonClicked()" i18n>
      Apply Cropping
    </lib-button>
  </div>
</div>
